<template>
  <v-card class="text-xs-center">
    <h1 class="text-pagename">Store Service</h1>
    <storeServiceTable />
  </v-card>
</template>

<script>
import storeServiceTable from "@/components/back-office/StoreManagement/StoreService/StoreServiceTable.vue";

export default {
  components: {
    storeServiceTable
  },
  destroyed() {
    this.$store.commit("fetchStoreBack/resetStateStoreService");
  },
  mounted() {
    const path = [
      {
        text: "Select province",
        disabled: false,
        href: "/weserve_admin_login/select/"
      },
      {
        text: "Select service",
        disabled: false,
        href: "/weserve_admin_login/control/" + this.$route.params.province
      },
      {
        text: "Store&Product",
        disabled: false,
        href:
          "/weserve_admin_login/control/" +
          this.$route.params.province +
          "/storeandproduct/storemanage"
      },
      {
        text: "Store Service list",
        disabled: true,
        href:
          "/weserve_admin_login/control/" +
          this.$route.params.province +
          "/storeandproduct/storeservicelist"
      }
    ];
    this.$store.commit("backOffice/saveRecentRoute", path);
  }
};
</script>

<style>
</style>
